import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PStatusMainLabelComponent } from './p-status-main-label.component';
import { PIconModule } from '@panaya/ui/p-icon';

@NgModule({
    declarations: [PStatusMainLabelComponent],
    imports: [CommonModule, PIconModule],
    exports: [PStatusMainLabelComponent]
})
export class PStatusMainLabelModule {}
